var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14135 5.69727C8.14135 6.44349 8.14135 11.3958 8.14135 11.3958C8.14135 11.3958 5.30545 11.3958 4.4781 11.3958C2.90453 11.3958 1.62891 10.1201 1.62891 8.54656C1.62891 6.97296 2.90453 5.69733 4.4781 5.69733C6.05167 5.69733 8.14135 5.69727 8.14135 5.69727Z",
    stroke: "currentColor",
    strokeWidth: 1.62811,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14062 5.69664V11.395L10.529 11.8925C12.154 12.2311 13.6368 13.0584 14.7784 14.2635C15.4663 14.9896 16.6882 14.5027 16.6882 13.5024V3.58925C16.6882 2.58894 15.4663 2.10204 14.7784 2.82822C13.6368 4.03324 12.1541 4.86048 10.5291 5.19904L8.14062 5.69664Z",
    stroke: "currentColor",
    strokeWidth: 1.62811,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07031 11.3965H8.14059L8.73819 15.2811C8.85199 16.0208 8.27971 16.6878 7.53134 16.6878H7.29377C6.81748 16.6878 6.38466 16.4109 6.18507 15.9785L4.07031 11.3965Z",
    stroke: "currentColor",
    strokeWidth: 1.62811,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorn);
export default __webpack_public_path__ + "static/media/horn.d943725c49ec46aa1d6b6843964b78e4.svg";
export { ForwardRef as ReactComponent };